module.exports = __webpack_public_path__ + "static/media/cbhead.9cdb56e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cbhead.jpg
// module id = 59
// module chunks = 0